import {
  useMemo, useEffect, useState, useRef,
} from 'react';
import { useHistory } from 'react-router-dom';
import { useStore } from '../../providers/store-provider/state.context';
import { useActions } from '../../providers/actions-provider/actions.context';
import createBreadcrumbsFromRoute from '../../../utils/create-breadcrumbs';
import isNumber from '../../../utils/is-number';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const MapReportData = (
  findFilter: string | null, sort: string, skip: number, pageSize: number,
  setHasAssetFilter: (value: boolean) => void,
) => {
  const { location: { pathname } } = useHistory();
  const { facilityActions, reportActions } = useActions();
  const [requestFindCache, setRequestFindCache] = useState <string>();
  const {
    groupTypes,
    groups,
    currentUser,
    executedReport,
    mapReport,
    mapReportDefinition,
  } = useStore();
  const [mapInfoLoaded, setMapInfoLoaded] = useState(false);
  // id for action
  const positionOfExec = pathname.indexOf('exec-');
  const positionOfID = pathname.indexOf('/', positionOfExec + 5);
  const group = pathname
    .slice(positionOfExec + 5, positionOfID === -1 ? pathname.length : positionOfID);
  const reportCode = pathname.split('/')[4] || '';
  function toLowerCase(v: string) { return v && v.toLowerCase(); }
  const prevPageSize = useRef(pageSize);

  useEffect(() => {
    const { find } = executedReport.data;
    const requestFind = findFilter === '' ? find : findFilter;
    if (requestFindCache !== requestFind || prevPageSize.current !== pageSize) {
      prevPageSize.current = pageSize;
      setRequestFindCache(requestFind);
      reportActions.getMapReport(reportCode, requestFind, sort, skip, pageSize);
    }
  }, [findFilter, sort, skip, pageSize, groups, executedReport.data]);

  useEffect(() => {
    const requestFind = (findFilter && findFilter !== '') ? findFilter : executedReport.data.find;
    let uid: string | null = null;
    let facility: string | null = null;
    if (requestFind) {
      try {
        const filters = JSON.parse(requestFind);
        if (filters?.$and) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const uidFilter = filters.$and.find((f: any) => f.uid?.$eq);
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const facilityFilter = filters.$and.find((f: any) => f.facility?.$eq);
          uid = uidFilter?.uid?.$eq ?? null;
          facility = facilityFilter?.facility?.$eq?.replaceAll('"', '') ?? null;
        } else {
          uid = filters?.uid?.$eq ?? null;
          facility = filters?.facility?.$eq?.replaceAll('"', '') ?? null;
        }
      } catch {
        // ignore parse errors
      }
    }
    setHasAssetFilter(!!(uid && facility));
  }, [findFilter, executedReport.data.find]);

  useEffect(() => {
    if (executedReport.loaded && groups.loaded && mapReport.data.code) {
      const { find } = executedReport.data;
      const requestFind = findFilter === '' ? find : findFilter;
      if (requestFind) {
        const filters = JSON.parse(requestFind);
        // eslint-disable-next-line
        const groupId = Object.values(groups.data).find((e: any) => {
          let facility;
          if (filters?.$and) {
            // eslint-disable-next-line
            const filter = filters.$and.find((f: any) => toLowerCase(Object.keys(f)[0]) == toLowerCase("facility") && f.facility.$eq);
            facility = filter?.facility?.$eq;
          } else {
            facility = filters?.facility && filters?.facility?.$eq.replaceAll('"', '');
          }
          return toLowerCase(e.code) === toLowerCase(facility);
        })?.id;
        if (groupId && reportCode.toUpperCase() === (mapReport.data.code).toUpperCase()
          && !mapInfoLoaded) {
          setMapInfoLoaded(true);
          facilityActions.getMapOrigin(groupId as unknown as string);
          facilityActions.getMapImage(groupId);
          const getReportArg = isNumber(group) ? group : executedReport.data.id;
          reportActions.mapReportDefinitionByReport(getReportArg as number);
          reportActions.getZonesForMap(groupId as unknown as string);
        }
      }
    }
  }, [findFilter, sort, skip, pageSize, groups, executedReport, mapReport.data.code]);
  return useMemo(() => {
    const initialValues = {};
    return ({
      title: 'Map',
      initialValues,
      routes: createBreadcrumbsFromRoute(pathname, groups.data, currentUser.data.tenant || ''),
      id: group,
    });
  }, [pathname, groupTypes, groups]);
};

export default MapReportData;
